import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig";

const API_URL = `${API_BASE_URL}/api/CareGap`;

const insertEvidence = async (evidenceData) => {
  try {
    const response = await axios.post(`${API_URL}/evidence`, evidenceData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error inserting evidence:", error?.response?.data || error);
    throw error;
  }
};

export default insertEvidence;
